import PropTypes from 'prop-types';
import EpicGamesNavImpl from 'epic-games-nav/app/scripts/EpicGamesNavImpl';
import {generateRoutePath} from '@epic-core/common';
import root from 'window-or-global';
import Immutable from 'seamless-immutable';
import {withLocalization} from '@epic-core/localization';

class EpicGamesNavWrapper extends EpicGamesNavImpl {
    static propTypes = {
        history: PropTypes.object.isRequired,
        location: PropTypes.object,
        headerStore: PropTypes.object
    };

    getCtaHref() {
        if (!root.location.origin) {
            root.location.origin = `${root.location.protocol}//${root.location.hostname}${root.location.port ? `:${root.location.port}` : ''}`;
        }
        return `${root.location.origin}/portal`;
    }

    setCTA(callToAction) {
        if (!callToAction || !callToAction.merge) return Immutable({});
        return callToAction.merge({
            href: this.getCtaHref()
        });
    }

    onSearch = query => {
        this.props.history.push(generateRoutePath(`/bing-search?keyword=${query}`));
    };

    setShieldOnClick(config) {
        return e => {
            e.preventDefault();
            const location = this.props.location || {};
            root.location.href = `https://www.epicgames.com/store${location.search || ''}`;
        };
    }

    setLinks(links) {
        if (!links) return Immutable([]);
        let updatedLinks = links;
        const history = this.props.history;
        for (let i = 0; i < updatedLinks.length; i++) {
            let link = updatedLinks[i];
            let external = true;
            if (link.useCustomCallback) {
                external = false;
                const linkPath = generateRoutePath(link.href);
                link = link.set('active', this.props.location.pathname === linkPath);
            }
            link = this.addOnClick(link, history, external);
            // We must go deeper!
            if (link.kids) {
                link = link.setIn(['kids', 'recursive'], true);
                link = link.set('kids', this.setLinks(link.kids));
            }
            updatedLinks = updatedLinks.setIn([i], link);
        }
        return updatedLinks;
    }
}

export default withLocalization(EpicGamesNavWrapper);
